module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagefooter"
  }, [_c('div', {
    staticClass: "footer_intro"
  }, [_c('div', {
    staticClass: "adress"
  }, [_c('ul', [_c('li', _vm._l((_vm.footRoute), function(item) {
    return _c('a', {
      key: item.name,
      on: {
        "click": function($event) {
          _vm.fRoute(item.fRoute)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "foot-contact"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "left",
      "width": "200",
      "trigger": "hover",
      "content": "请拨打 400-1556-256 免费咨询服务热线"
    }
  }), _vm._v(" "), _c('el-popover', {
    ref: "popover3",
    attrs: {
      "placement": "right",
      "width": "100",
      "trigger": "hover"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "src": require("../assets/imgs/qrd.png")
    }
  })]), _vm._v(" "), _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "icon1"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon2"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover3",
      arg: "popover3"
    }],
    staticClass: "icon3"
  })], 1)]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p', {
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_vm._v("公司地址 北京市朝阳区慧忠里103号洛克时代中心A座703")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("京ICP备15053121号-1 京ICP证160142号 Copyright©2015LuxuryKingDom 保留所有版权")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ecf4c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foot.vue
// module id = 195
// module chunks = 1